module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"start":{"partner_carousel":{"title":"Mehr Beiträge unserer Partner finden Sie in den Firmenprofilen:"}}}}}}')
  delete Component.options._Ctor
}
